// extracted by mini-css-extract-plugin
module.exports = {"countdown":"on-z","srOnly":"pn-z"};